import {name, mixins, props, data, validationsRules, parseValidations, parseValidationSetup, EventBus} from './config'
import {setValidationRule} from '../../../../lib/validations'

const validationGroupRules = {
  personalDetails: [
    'firstName', 'lastName', 'email', 'emailConfirmation'
  ],
  personalDetailsWithPhone: [
    'firstName', 'lastName', 'email', 'emailConfirmation', 'phone', 'phoneConfirmation'
  ],
  gifteeDetails: [
    'gifteeFirstName', 'gifteeLastName', 'gifteeEmail', 'gifteeEmailConfirmation'
  ],
  gifteeDetailsWithPhone: [
    'gifteeFirstName', 'gifteeLastName', 'gifteeEmail', 'gifteeEmailConfirmation','gifteePhone', 'gifteePhoneConfirmation'
  ]
}

export default {
  name,
  props,
  mixins,

  data() {
    return {
      ...data,
      termsAgreed: 'no',
      editMode: false,
      count: 1,
      validations: {},
      isSubmitting: false
    }
  },
  watch: {
    giftCardPreviewing() {
      this.lazyScrollTo('.re-page')
    },
  },

  validations() {
    return {
      ...parseValidations(validationsRules),
      ...validationGroupRules
    }
  },

  computed: {
    showAgreeToTermsBox() {
      return !this.noAgreeToTerms
    },
    disabledAmountBox() {
      return this.showAgreeToTermsBox && this.termsAgreed !== 'yes'
    },
    disabledPersonalDetails() {
      return !this.productId
    },
    isPersonalDetailsInvalid() {
      return this.noPhoneInput ? this.$v.personalDetails.$invalid : this.$v.personalDetailsWithPhone.$invalid
    },
    disabledRecipientBox() {
      return this.disabledPersonalDetails || this.isPersonalDetailsInvalid
    },
    disabledRecipientDetails() {
      return !this.giftee
    },
    isGifteeDetailsInvalid() {
      return this.giftee && (this.noPhoneInput ? this.$v.gifteeDetails.$invalid : this.$v.gifteeDetailsWithPhone.$invalid)
    },
    isPersonalOrGifteeDetailsInvalid() {
      return this.isGifteeDetailsInvalid ||  this.isPersonalDetailsInvalid
    },
    isGifteeNoteInvalid() {
      return this.giftee && this.$v.giftNote && this.$v.giftNote.$invalid
    },
    disabledCardProcessor() {
      return this.disabledRecipientBox || this.isGifteeDetailsInvalid || this.isGifteeNoteInvalid
    },
    showPhoneInput() {
      return !this.noPhoneInput
    },
    cardPreviewHtml() {
      return this.giftCardPreviewHtml
      // return this.previewCardBoxHtml || this.giftCardPreviewHtml
    }
  },

  async created() {
    if (this.isGiftNoteRequired) {
      validationsRules.giftNote = setValidationRule('giftNote', {
        required: {error: 'Note is required.'}
      })
    }
    this.validations = parseValidationSetup(validationsRules, this)
    this.editMode = !!this.token || !!this.item || !!this.giftCardEditItem

    if (this.authenticated) {
      this.firstName = this.user.first_name
      this.lastName = this.user.last_name
      this.email = this.emailConfirmation = this.user.email
      this.phone = this.phoneConfirmation = this.user.meta.phone
    }

    if (this.editMode) {
      EventBus.$emit('giftcard.before.edit')
      this.termsAgreed = 'yes'
      const editItem = this.giftCardEditItem || this.cartItems[this.token || this.item]
      this.count = editItem.payload.count
      this.hydrateCardFromCart(editItem)
    }
  },

  methods: {

    validateCardInputs() {
      this.$v.$touch()
      this.formSubmitting = true
      return !this.disabledCardProcessor
    },

    processCard() {
      if (!this.validateCardInputs()) {
        this.scrollToFirstErrorElement()
      } else {
        if (this.giftee) {
          EventBus.$emit('giftcard.preview')
          this.showGiftCardPreview()
        } else {
          this.addCardToCart()
        }
      }
    },

    hydrateCardFromCart(cartItem) {
      this.setGiftCardInEditMode()
      const items = this.localGiftCardCartItems
      const item = items[cartItem.id || cartItem.cartId]
      this.setGiftCardInput(item)
      this.phoneConfirmation = this.phone
      this.gifteeEmailConfirmation = this.gifteeEmail
      this.gifteePhoneConfirmation = this.gifteePhone
      this.setGiftCardEditItem(null)
      EventBus.$emit('giftcard.edit')
    },

    addCardToCart() {
      this.formSubmitting = true
      EventBus.$emit('giftcard.before.add-to-cart')
      this.cardReadyForCart = true
      this.isSubmitting = true
      const item = this.proposedGiftCardCart
      item.editRoute = {name: 'giftcards.buy'}
      item.payload.count = this.count
      this.setGiftCardInput({cartId: item.id})
      this.setLocalGiftCardCartItem(_.clone(this.giftCardInput(), true))

      item.editable =  this.cartItemEditable
      if (this.editItem) {
        item.id = this.editItem.id
      }

      if (this.editMode) {
        this.updateCartItem(item)
      } else {
        this.addCartItem(item)
      }

      this.setGiftCardEditItem(null)
      EventBus.$emit('buy.giftcard.add-to-cart')
    }
  },
}
